import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import server from "src/api/server";
import Seo from "src/components/shared/Seo";

const PoliciesPage = dynamic(() =>
  import("src/modules/PoliciesPage/PoliciesPage")
);

export default function Policies({ data, appSetting, footerSettings }) {
  const router = useRouter();
  const { locale } = router;

  const customMeta = [
    { name: "title", content: data?.title?.[locale] },
    { name: "description", content: data?.title?.[locale] },
  ];

  return (
    <>
      <Seo
        metaData={customMeta}
        appSetting={{ ...appSetting, ...footerSettings }}
        pageUrl={
          typeof window !== "undefined"
            ? window.location.href
            : `${process.env.NEXT_PUBLIC_SITE_URL}${router.asPath}`
        }
      />
      <PoliciesPage data={data} footerSettings={footerSettings} />
    </>
  );
}

export async function getStaticProps() {
  try {
    const [postRes, indexRes, footerRes] = await Promise.all([
      server.get("/api/posts/655"),
      server.get("/api/index"),
      server.get("/api/footer"),
    ]);

    return {
      props: {
        data: postRes?.data?.data?.data || null,
        appSetting: indexRes?.data?.data?.AppSetting || null,
        footerSettings: footerRes?.data?.data || null,
      },
      revalidate: 60,
    };
  } catch (error) {
    console.error("Error fetching policies page data:", error.message);
    return {
      props: {
        data: null,
        appSetting: null,
        footerSettings: null,
      },
      revalidate: 60,
    };
  }
}
